module.exports = "/images/yes_icon.svg?f04f1b61f0512db6d4c20f1ae72031e6";